import {
  type WorkerPaymentDetailsResponse,
  workerPaymentsContract,
} from "@clipboard-health/contract-worker-app-bff";
import { useGetQuery } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";

export function useGetWorkerPaymentDetails(
  paymentId: string
): UseQueryResult<WorkerPaymentDetailsResponse> {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/worker-payments/${paymentId}`,
    responseSchema: workerPaymentsContract.details.responses[200],
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_PAYMENT_DETAILS_FAILURE,
      userErrorMessage: "Failed to load payment details",
    },
  });
}
